<template>
    <div class="relative">
        <div class="my-8 w-full lg:my-16">
            <div
                class="mx-auto flex justify-center"
                ref="FrontendPracticeQuizQuestion"
            >
                <ul class="flex items-center">
                    <li
                        v-for="quiz in practiceQuizzes"
                        @click="changeSelectedQuiz(quiz)"
                        :class="
                            'border border-r-0 border-gray-500 p-4 first:rounded-l last:rounded-r last:border-r hover:cursor-pointer' +
                            ' ' +
                            (selectedQuiz.level.id === quiz.level.id
                                ? 'bg-primary-500 text-white'
                                : '')
                        "
                    >
                        {{ quiz.level.title }}
                    </li>
                </ul>
            </div>

            <div class="relative w-full py-8 lg:py-16">
                <div
                    class="h-full w-full rounded border border-gray-400 bg-white p-8"
                >
                    <div v-if="processingQuiz" class="h-[500px] h-full">
                        <div class="flex h-full flex-col justify-center gap-4">
                            <div class="flex justify-center">
                                <img
                                    class="animate animate-spin"
                                    src="/assets/art/calculating_quiz_spinner.png"
                                />
                            </div>
                            <div class="text-center text-[18px] font-semibold">
                                Calculating your score...
                            </div>
                        </div>
                    </div>
                    <div class="" v-else-if="graded">
                        <frontend-practice-quiz-results
                            :graded-quiz-questions="gradedQuizQuestions"
                            :score="score"
                            v-on:practice-question-answered="resetPosition"
                        />
                    </div>
                    <div class="" v-else>
                        <frontend-practice-quiz-questions
                            :questions="selectedQuiz.questions"
                            v-on:grade-quiz="gradeQuiz"
                            v-on:practice-question-answered="resetPosition"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FrontendPracticeQuizResults from "@/Components/FrontendPracticeQuizResults";
import FrontendPracticeQuizQuestions from "@/Components/FrontendPracticeQuizQuestions";

export default {
    name: "FrontendPracticeQuiz",
    components: { FrontendPracticeQuizQuestions, FrontendPracticeQuizResults },
    props: {
        practiceQuizzes: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            selectedQuiz: this.practiceQuizzes[1],
            gradedQuizQuestions: [],
            score: 0,
            graded: false,
            processingQuiz: false,
        };
    },
    methods: {
        changeSelectedQuiz(quiz) {
            this.graded = false;
            this.processingQuiz = false;
            this.gradedQuizQuestions = [];
            this.selectedQuiz = quiz;
        },
        gradeQuiz(quizQuestions) {
            let vm = this;
            vm.processingQuiz = true;

            vm.score = 0;

            let studentAnswers = [];

            quizQuestions.forEach(function (question) {
                let selectedAnswers = [];

                question.shuffled_answers.forEach(function (answer) {
                    if (answer.isSelected) {
                        selectedAnswers.push(answer.id);
                    }
                });

                studentAnswers.push({
                    questionId: question.id,
                    studentAnswers: selectedAnswers,
                });
            });

            axios
                .post(
                    route("frontend.features.practice-quiz.submit"),
                    studentAnswers
                )
                .then(function (response) {
                    vm.score = Math.round(response.data.score * 100);

                    setTimeout(function () {
                        vm.gradedQuizQuestions = response.data.questions;
                        vm.processingQuiz = false;
                    }, 250);
                });

            vm.graded = true;
        },
        resetPosition(callback) {
            const el = this.$refs.FrontendPracticeQuizQuestion;

            el.scrollIntoView();

            if (typeof callback != 'undefined') {
                callback();
            }
        },
    },
};
</script>
